/**
 * ErrorReporter — dërgon errors te backend /api/client-error
 * Backend i ruan në DB dhe dërgon Telegram alert me kontekst të plotë.
 */
import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ErrorReporterService {
  private queue: any[] = [];
  private sending = false;

  constructor(private http: HttpClient) {}

  report(error: any, context?: string): void {
    const user = this.getUser();
    const payload = {
      message: this.extractMessage(error),
      stack: error?.stack?.slice(0, 3000) || null,
      url: window.location.href,
      context: context || null,
      user_email: user?.email || null,
      user_role: user?.role || null,
      timestamp: new Date().toISOString(),
    };
    this.queue.push(payload);
    this.flush();
  }

  reportHttpError(status: number, url: string, body: any): void {
    // Mos raportoi 401/403/404 — janë normale
    if ([401, 403, 404].includes(status)) return;
    const user = this.getUser();
    const payload = {
      message: `HTTP ${status} @ ${url}: ${body?.error || body?.message || JSON.stringify(body)?.slice(0, 200)}`,
      stack: null,
      url: window.location.href,
      context: `HTTP Error: ${url}`,
      user_email: user?.email || null,
      user_role: user?.role || null,
      http_status: status,
      timestamp: new Date().toISOString(),
    };
    this.queue.push(payload);
    this.flush();
  }

  private flush(): void {
    if (this.sending || this.queue.length === 0) return;
    this.sending = true;
    const batch = this.queue.splice(0, 10); // max 10 njëherësh
    this.http.post(`${environment.apiUrl}/client-error`, { errors: batch })
      .subscribe({
        next: () => { this.sending = false; if (this.queue.length) this.flush(); },
        error: () => { this.sending = false; } // nëse backend është down, hedhim
      });
  }

  private extractMessage(error: any): string {
    if (typeof error === 'string') return error.slice(0, 500);
    if (error?.message) return error.message.slice(0, 500);
    if (error?.error?.message) return error.error.message.slice(0, 500);
    return String(error).slice(0, 500);
  }

  private getUser(): any {
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload;
    } catch { return null; }
  }
}

/**
 * Angular Global ErrorHandler — kap çdo exception të pa-kapur
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private reporter: ErrorReporterService) {}

  handleError(error: any): void {
    // Mos raportoi chunk loading errors (normal me lazy loading)
    const msg = error?.message || String(error);
    if (msg.includes('ChunkLoadError') || msg.includes('Loading chunk')) return;

    this.reporter.report(error?.originalError || error, 'GlobalErrorHandler');
    console.error('[GlobalError]', error);
  }
}
